// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__mu2mo","infoIcon":"styles_infoIcon__kMuqf"};